import {Module} from "vuex";
import {RootState} from "@/store/types";
import {originatorRules} from "@/store/rules/originator_rules";

export const rulesModule: Module<any, RootState> = {
  modules: {
    originatorRules
  }
}
